import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import { listIrregularProducts } from 'store/Orbita/Product/actions';

import QuickView from './components/Quickview';
import styles from '../../styles/';
import ProductTable from '../ProductTable';

import type { DispatchProp } from 'react-redux';
import type { RouteComponentProps } from 'react-router-dom';

interface IProps extends DispatchProp<any>, RouteComponentProps<any> {
  irregularProducts: any;
  classes: any;
  search: string;
  history: any;
  pagination: any;
  user: any;
}

interface IStates {
  activeQuickView: boolean;
  dataProduct: any;
}

class Irregular extends React.Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      activeQuickView: false,
      dataProduct: null,
    };
  }

  onChangeRowsPerPage = (per_page: number) => {
    this.loadIrregularProducts({ ...this.props.pagination, ...{ current_page: 1, per_page } }, this.props.search);
  };

  onChangePage = (page: number) => {
    this.loadIrregularProducts({ ...this.props.pagination, ...{ current_page: page } }, this.props.search);
  };

  loadIrregularProducts = (pagination: any, title: string) => {
    (async () => {
      try {
        await this.props.dispatch(listIrregularProducts(pagination, title));
      } catch (error) {
        toast.error(error);
      }
    })();
  };

  onClickOptions(product: any) {
    this.setState({
      activeQuickView: true,
      dataProduct: product,
    });
  }

  componentDidMount() {
    this.loadIrregularProducts({ current_page: 1, per_page: 10 }, this.props.search);
  }

  render() {
    const { irregularProducts, pagination } = this.props;

    return (
      <>
        <ProductTable
          products={irregularProducts.data}
          order=''
          listProductsChildren={irregularProducts}
          onClickOptions={(product: any) => this.onClickOptions(product)}
          coproduction={false}
          irregular={true}
          isLoading={irregularProducts?.isFetching}
          pagination={{
            current_page: pagination?.current_page ?? 1,
            per_page: pagination?.per_page ?? 10,
            total: pagination?.total_items,
            optionsPerPage: pagination?.optionsPerPage ?? '10,20,30,40',
            onChangePage: this.onChangePage,
            onChangePerPage: this.onChangeRowsPerPage,
          }}
        />

        <QuickView
          active={this.state.activeQuickView}
          changeActive={() => {
            this.setState({ activeQuickView: !this.state.activeQuickView });
          }}
          productData={this.state.dataProduct}
        />
      </>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    irregularProducts: state.orbita.Product.listIrregularProducts,
    pagination: state.orbita.Product.listIrregularProducts.pagination,
  };
}

export default withRouter(connect(mapStateToProps)(styles(Irregular)));
